import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AWSLambda } from 'src/app/AWSLambda.service';
import { TranslateService } from '@ngx-translate/core';
import { BoRolesCheckService } from "../../../components/rolesCheck/bo-roles-check.service";
import { Router } from '@angular/router';

@Component({
  selector: 'app-add-balance',
  templateUrl: './AddBalance.Component.html',
})
export class AddBalanceComponent implements OnInit {
  lambda = inject(AWSLambda);
  rolesCheck = inject(BoRolesCheckService);
  canAccess = false;
  userid!: string;
  monto!: number;
  motivo!: string;

   motivos = ['GIFT','COMPENSATION','PROMOTION','ADJUSTMENT','BONUS','COURTESY','REFUND'];

  constructor(
    private route: ActivatedRoute,
    private router: Router, 
    private translate: TranslateService
  ) {}

  async ngOnInit() {
    this.canAccess = await this.rolesCheck.checkAccess();
      if (!this.canAccess) {
        return;
      }
    this.userid = this.route.snapshot.queryParamMap.get('user') || '';
  }

  async enviarRecarga() {
    if (!this.userid || !this.monto || !this.motivo) {
      alert('Por favor completa todos los campos');
      return;
    }

    // Traducción dinámica
    const confirmText = this.translate.instant('ADDBALANCE.CONFIRM_TEXT', {
      monto: this.monto
    });

    if (!confirm(confirmText)) {
      return; // Si el usuario cancela, no enviamos nada
    }

    const queryParams = {
      user: this.userid,
      monto: this.monto,
      motivo: this.motivo
    };

    try {
      const response = await this.lambda.getLambdaFunction(
        'lambda',
        '/add/balance',
        { queryStringParameters: queryParams }
      );

      alert('Saldo agregado con éxito');
      console.log('Respuesta API:', response);
      this.router.navigate(['/backoffice/users', this.userid ]);
    } catch (error) {
      console.error(error);
      alert('Error al agregar saldo');
    }
  }
}